import { render, staticRenderFns } from "./search-hero-with-overflow.vue?vue&type=template&id=5744b440&scoped=true&"
import script from "./search-hero-with-overflow.vue?vue&type=script&lang=js&"
export * from "./search-hero-with-overflow.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=5744b440&scoped=true&lang=css&"
import style1 from "./search-hero-with-overflow.vue?vue&type=style&index=1&id=5744b440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5744b440",
  null
  
)

export default component.exports